




























































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import _ from "lodash";
import moment from "moment";
import CreateCollectionCode from "./create-collectionCode.vue";
import PrintCollectionCodes from "./print-collectionCode.vue";

class PageCollectionCodeRequest extends PageRequest {
  keyword: string;
  status: string;
  type: string;
  fromDate: Date;
  toDate: Date;
}

@Component({
  components: {
    "create-collection-code": CreateCollectionCode,
    "print-collection-code": PrintCollectionCodes,
  },
})
export default class CollectionCode extends mixins(ListMixin, AbpBase) {
  namespace = "collectionCode";
  statuses = [];
  types = [];
  createModalShow: boolean = false;
  printModalShow: boolean = false;
  pagerequest: PageCollectionCodeRequest = new PageCollectionCodeRequest();
  creationTime: Date[] = [];
  selectedItems = [];
  pageTitlePopup: string = "printer";
  get store() {
    return this.$store.state.collectionCode;
  }
  get items() {
    return this.store.items;
  }
  preGetPage() {
    this.pagerequest.fromDate = null;
    this.pagerequest.toDate = null;

    if (
      this.creationTime.length > 0 &&
      !_.isNil(this.creationTime[0]) &&
      this.creationTime[0].toString() !== ""
    ) {
      this.pagerequest.fromDate = moment(this.creationTime[0])
        .startOf("d")
        .toDate();
    }
    if (
      this.creationTime.length > 1 &&
      !_.isNil(this.creationTime[1]) &&
      this.creationTime[1].toString() !== ""
    ) {
      this.pagerequest.toDate = moment(this.creationTime[1])
        .endOf("d")
        .toDate();
    }
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = this.currentPage;
    this.preGetPage();
    await this.$store
      .dispatch({
        type: `${this.namespace}/getAll`,
        data: this.pagerequest,
      })
      .catch(() => {
        this.store.loading = false;
      });
  }
  async getStatuses() {
    await this.$store
      .dispatch({
        type: `${this.namespace}/getStatusesForSelect`,
        data: {
          hasAllItem: true,
        },
      })
      .then(() => {
        var re = this.store.statuses;
        this.pagerequest.status = re[0].id;
        this.statuses = re;
      });
  }
  async getTypes() {
    await this.$store
      .dispatch({
        type: `${this.namespace}/getTypesForSelect`,
        data: {
          hasAllItem: true,
        },
      })
      .then(() => {
        var re = this.store.types;
        this.pagerequest.type = re[0].code;
        this.types = re;
      });
  }
  async exportToExcel() {
    this.preGetPage();
    await this.$store.dispatch({
      type: `${this.namespace}/export`,
      data: this.pagerequest,
    });
  }
  create() {
    this.createModalShow = true;
  }
  print() {
    this.printModalShow = true;
  }
  onSelect(selection, row) {
    this.$emit("on-select", selection, row);
  }
  onSelectCancel(selection, row) {
    this.$emit("on-select-cancel", selection, row);
  }
  onSelectAll(selection) {
    this.$emit("on-select-all", selection);
    _.forEach(this.list, (o) => {
      o._checked = true;
    });
    this.selectedItems = this.list;
  }
  onSelectionChange(selection) {
    this.$emit("on-selection-change", selection);
    _.forEach(this.list, (o) => {
      var itemSelected = _.find(selection, function(x) {
        return x.id === o.id;
      });
      if (itemSelected) {
        o._checked = true;
      } else {
        o._checked = false;
      }
    });
    this.selectedItems = this.list.filter((item) => item._checked);
  }
  get selectedCodes() {
    return _.map(this.selectedItems, (i) =>
      _.pick(i, "mainSerialNo", "subSerialNo", "hiddenCode")
    );
  }
  onCancelPopupPrinter() {
    this.printModalShow = false;
  }

  onDownloadFilePrinter() {
    this.printModalShow = false;
    this.getpage();
  }

  columns = [
    {
      type: "selection",
      width: 60,
      align: "center",
      key: "_checked",
    },
    {
      title: Util.L("HiddenCode"),
      width: 150,
      slot: "hiddenCode",
    },
    {
      title: Util.L("MainSerialNo"),
      width: 150,
      key: "mainSerialNo",
    },
    {
      title: Util.L("SubSerialNo"),
      width: 150,
      key: "subSerialNo",
    },
    {
      title: Util.L("Status"),
      width: 150,
      key: "statusText",
    },
    {
      title: Util.L("SKU"),
      width: 150,
      key: "sku",
    },
    {
      title: Util.L("ProductName"),
      width: 200,
      key: "productName",
    },
    {
      title: Util.L("ExportBrandName"),
      width: 200,
      key: "exportBrandName",
    },
    {
      title: Util.L("AssetType"),
      width: 200,
      key: "assetTypeName",
    },
    {
      title: Util.L("ConditionType"),
      width: 200,
      key: "conditionTypeName",
    },
    {
      title: Util.L("Warehouse"),
      width: 150,
      key: "warehouseCode",
      render: (h: any, params: any) => {
        if (
          _.isNil(params.row.warehouseCode) ||
          _.isEmpty(params.row.warehouseCode)
        )
          return "";
        return h(
          "span",
          `${params.row.warehouseCode}-${params.row.warehouseName}`
        );
      },
    },
    {
      title: Util.L("Type"),
      width: 150,
      key: "typeText",
    },
    {
      title: Util.L("CreationTime"),
      key: "creationTime",
      width: 150,
      render: (h: any, params: any) => {
        return h("span", Util.toViewDateString(params.row.creationTime));
      },
    },
  ];
  async created() {
    await this.getStatuses();
    await this.getTypes();
    var defaultDate = new Date();
    var defaultDateFrom = moment()
      .add(-7, "d")
      .toDate();
    this.creationTime = [defaultDateFrom, defaultDate];
  }
}
